import React from 'react';
import DatePicker from '@src/components/date-picker/DatePicker';
import Checkbox from '@src/components/checkbox/Checkbox';
import styles from './DateRangeFilter.module.scss';

type DateRangeFilterProps = {
  startDate: any;
  endDate: any;
  onStartDateChange: (date: any, dateString: string) => void;
  onEndDateChange: (date: any, dateString: string) => void;
  excludeZeroResponses?: boolean;
  onExcludeZeroResponsesChange?: () => void;
  includeSent?: boolean;
  onIncludeSentChange?: () => void;
  startDateLabel?: string;
  endDateLabel?: string;
  excludeZeroResponsesLabel?: string;
  includeSentLabel?: string;
};

/**
 * DateRangeFilter - A reusable component for date range filtering with checkboxes
 */
const DateRangeFilter: React.FC<DateRangeFilterProps> = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  excludeZeroResponses,
  onExcludeZeroResponsesChange,
  includeSent,
  onIncludeSentChange,
  startDateLabel = 'Start Date',
  endDateLabel = 'End Date',
  excludeZeroResponsesLabel = 'Only include surveys with responses',
  includeSentLabel = 'Include surveys that are already sent'
}) => {
  return (
    <div className={styles.dateRangeFilter}>
      <div className={styles.datePickersRow}>
        <DatePicker 
          label={startDateLabel} 
          value={startDate} 
          onChange={onStartDateChange} 
        />
        <DatePicker 
          label={endDateLabel} 
          value={endDate} 
          onChange={onEndDateChange} 
        />
        {excludeZeroResponses !== undefined && onExcludeZeroResponsesChange && (
          <Checkbox
            label={excludeZeroResponsesLabel}
            checked={excludeZeroResponses}
            onChange={onExcludeZeroResponsesChange}
          />
        )}
        {includeSent !== undefined && onIncludeSentChange && (
          <Checkbox
            label={includeSentLabel}
            checked={includeSent}
            onChange={onIncludeSentChange}
          />
        )}
      </div>
    </div>
  );
};

export default DateRangeFilter;
